var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { LocalStorageKeys } from '@/types';
import sleep from '@/plugins/sleep';
import apiClient from '@/plugins/api-client';
import casApiClient from '@/plugins/cas-api-client';
import { getAuthItem, setAuthItem } from '@/plugins/auth-storage';
// 最大のリトライ回数を制限します
var MAX_RETRY_COUNT = 1;
var JWTKey = LocalStorageKeys.JWT;
var RefreshTokenKey = LocalStorageKeys.RefreshToken;
var DeviceUUIDKey = LocalStorageKeys.DeviceUUID;
var state = Vue.observable({
    isRefreshing: false
});
export default (function () {
    apiClient.interceptors.request.use(function (config) {
        var token = getAuthItem(JWTKey);
        if (!config.headers.Authorization && token) {
            config.headers.Authorization = "Bearer " + token;
        }
        var deviceId = getAuthItem(DeviceUUIDKey);
        if (!config.headers['X-Device-UUID'] && deviceId) {
            config.headers['X-Device-UUID'] = deviceId;
        }
        return config;
    }, function (err) {
        return Promise.reject(err);
    });
    var refreshConfig = function (config) {
        if (Number.isInteger(config.isRetry)) {
            config.isRetry += 1;
        }
        else {
            config.isRetry = 1;
        }
        config.headers.Authorization = "Bearer " + getAuthItem(JWTKey);
        // payloadがjson文字列化されている場合は復元します
        if (typeof config.data === 'string') {
            config.data = JSON.parse(config.data);
        }
        return config;
    };
    var onFulfilledResponse = function (response) {
        return response;
    };
    var onRejectedResponse = function (err) { return __awaiter(void 0, void 0, Promise, function () {
        var params, res, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!err.response || !err.response.data || !err.response.data.is_expired) {
                        return [2 /*return*/, Promise.reject(err)];
                    }
                    if (Number.isInteger(err.config.isRetry) && MAX_RETRY_COUNT >= err.config.isRetry) {
                        return [2 /*return*/, Promise.reject(err)];
                    }
                    if (!state.isRefreshing) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    if (!state.isRefreshing) return [3 /*break*/, 3];
                    return [4 /*yield*/, sleep()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, apiClient.request(refreshConfig(err.config))];
                case 4:
                    state.isRefreshing = true;
                    params = {
                        refresh_token: getAuthItem(RefreshTokenKey),
                        device_uuid: getAuthItem(DeviceUUIDKey),
                        user_agent: navigator.userAgent
                    };
                    _a.label = 5;
                case 5:
                    _a.trys.push([5, 7, 8, 9]);
                    return [4 /*yield*/, casApiClient.put('/users/refresh', params)];
                case 6:
                    res = _a.sent();
                    setAuthItem(JWTKey, res.data.idToken);
                    setAuthItem(RefreshTokenKey, res.data.refresh_token);
                    return [3 /*break*/, 9];
                case 7:
                    e_1 = _a.sent();
                    return [2 /*return*/, Promise.reject(err)];
                case 8:
                    state.isRefreshing = false;
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/, apiClient.request(refreshConfig(err.config))];
            }
        });
    }); };
    apiClient.interceptors.response.use(onFulfilledResponse, onRejectedResponse);
});
